var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#AAAAA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6564 10.6821C20.8784 10.3486 19.8781 10.4598 19.3224 11.1266L13.6543 16.6836H10.6535C9.09754 16.6836 7.875 18.0173 7.875 19.6844V22.2406C7.875 23.9077 9.09754 25.2414 10.6535 25.2414H13.5431L19.2113 30.7984C19.6558 31.243 20.2115 31.4652 20.7672 31.4652C21.1007 31.4652 21.3229 31.3541 21.6564 31.243C22.5455 30.9095 23.1012 30.0204 23.1012 29.0202V12.9049C23.1012 11.9046 22.5455 11.0155 21.6564 10.6821ZM20.8784 28.909C20.8784 29.0202 20.8784 29.1313 20.8784 29.1313L14.5434 23.0186H10.6535C10.3201 23.0186 10.0978 22.6852 10.0978 22.2406V19.6844C10.0978 19.2398 10.4312 18.9064 10.6535 18.9064H14.4323L20.7672 12.7937C20.7672 12.7937 20.8784 12.9049 20.8784 13.016V28.909Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4348 17.6839C26.6571 17.6839 26.8794 17.5728 27.1017 17.4617L33.2144 12.4604C33.6589 12.0158 33.7701 11.349 33.3255 10.9044C32.9921 10.4598 32.2141 10.3487 31.7695 10.7933L25.6568 15.7946C25.2123 16.2391 25.1011 16.906 25.5457 17.3505C25.768 17.5728 26.1014 17.6839 26.4348 17.6839Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1017 24.4637C26.6571 24.0191 25.8791 24.1302 25.5457 24.5748C25.1011 25.0194 25.2123 25.7974 25.6568 26.1308L31.7695 31.1321C31.9918 31.3544 32.2141 31.3544 32.4364 31.3544C32.7698 31.3544 33.1032 31.2432 33.3255 30.9098C33.7701 30.4652 33.6589 29.6873 33.2144 29.3538L27.1017 24.4637Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3259 19.7954H28.6578C27.9909 19.7954 27.5464 20.24 27.5464 20.9068C27.5464 21.5737 27.9909 22.0182 28.6578 22.0182H34.3259C34.9928 22.0182 35.4373 21.5737 35.4373 20.9068C35.4373 20.24 34.9928 19.7954 34.3259 19.7954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioBw);
export default __webpack_public_path__ + "static/media/audio_bw.835d096929ceb39cdb8a54184520145c.svg";
export { ForwardRef as ReactComponent };